import { render, staticRenderFns } from "./AssigneesChip.vue?vue&type=template&id=13e2be9e"
import script from "./AssigneesChip.vue?vue&type=script&lang=js"
export * from "./AssigneesChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports